import userProfile from './userProfile';

export default userProfile;
